import * as Yup from 'yup';
import { messages } from 'utils/validation/validation-messages';

export const usernameValidationRule = Yup.string().email(messages.username.invalid);
export const passwordValidationRule = Yup.string()
	.min(8, messages.password.isShort)
	.max(120, messages.password.isLong);
